<template>
  <b-card
    class="card-tiny-line-stats"
  >
    <h6 class="mb-2">
      {{ title }}
    </h6>
    <hr class="mb-0">
    <div v-if="!loading && data.length">
      <div>
        <b-list-group flush>
          <b-list-group-item
            v-for="(item, index) in data"
            :key="`list-item-search-${index}`"
            class="d-flex justify-content-between align-items-center"
          >
            <span v-if="item.search">{{ index+1 }}. {{ item.search }}</span>
            <span
              v-else
            >{{ index+1 }}. <i class="text-muted"> Keyword kosong</i></span>
            <b-badge
              variant="light-primary"
              pill
              class="badge-round"
            >
              {{ item.count }} kali
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>

    <div
      v-if="!loading && !data.length"
      class="my-5 text-center"
    >
      Data tidak ditemukan
    </div>

    <div v-if="loading">
      <b-row
        v-for="(item, index) in [1,2,3,4,5]"
        :key="`load-${index}`"
        class="mb-2"
      >
        <b-col cols="6">
          <b-skeleton
            animation="wave"
            :width="index%2===0 ? '90%' : '100%'"
          />
        </b-col>
        <b-col cols="4" />
        <b-col cols="2">
          <b-skeleton animation="wave" />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BListGroup,
  BListGroupItem,
  BBadge,
  BSkeleton,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
    BSkeleton,
    BRow,
    BCol,
  },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
